import { render, staticRenderFns } from "./MobileBuyArea.vue?vue&type=template&id=66d4e128&scoped=true&"
import script from "./MobileBuyArea.vue?vue&type=script&lang=js&"
export * from "./MobileBuyArea.vue?vue&type=script&lang=js&"
import style0 from "./MobileBuyArea.vue?vue&type=style&index=0&id=66d4e128&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4e128",
  null
  
)

export default component.exports